export enum LegacyUrl {
  approach,
  askForProductsLetterForRestaurants,
  askForProductsLetterForShops,
  becomeMember,
  contact,
  discontinuedProducts,
  history,
  home,
  memberArea,
  memberGeneralMeetings,
  memberNews,
  memberTools,
  mobilisation,
  news,
  ouVaNotreArgent,
  press,
  productBarcodes,
  professionals,
  statutes,
}

export const legacyUrls = {
  [LegacyUrl.approach]: urlTo("/demarche-collective-et-solidaire/"),
  [LegacyUrl.askForProductsLetterForRestaurants]: urlTo(
    "/wp-content/uploads/2024/07/lettres-demande-arrivee-rhf.pdf",
  ),
  [LegacyUrl.askForProductsLetterForShops]: urlTo(
    "/wp-content/uploads/2022/11/lettre-de-demande-de-produits-a-donner-a-nos-magasins.pdf",
  ),
  [LegacyUrl.becomeMember]: urlTo("/devenir-societaire/"),
  [LegacyUrl.contact]: urlTo("/contactez-nous/"),
  [LegacyUrl.discontinuedProducts]: urlTo("/produits-suspendus/"),
  [LegacyUrl.history]: urlTo("/nos-convictions-et-notre-histoire-collective/"),
  [LegacyUrl.home]: urlTo("/"),
  [LegacyUrl.memberArea]: urlTo("/espace-societaire-2/"),
  [LegacyUrl.memberGeneralMeetings]: urlTo("/assemblees-generales/"),
  [LegacyUrl.memberNews]: urlTo("/actualites-societaires/"),
  [LegacyUrl.memberTools]: urlTo("/boite-a-outils/"),
  [LegacyUrl.mobilisation]: urlTo(
    "/notre-mobilisation-pour-des-fruits-legumes-equitables/",
  ),
  [LegacyUrl.news]: urlTo("/category/blog/"),
  [LegacyUrl.ouVaNotreArgent]: urlTo("/ou-va-notre-argent/"),
  [LegacyUrl.press]: urlTo("/espace-presse/"),
  [LegacyUrl.productBarcodes]: urlTo(
    "/wp-content/uploads/2022/07/05-24-listing-produits.pdf",
  ),
  [LegacyUrl.professionals]: urlTo("/professionnel-de-la-restauration/"),
  [LegacyUrl.statutes]: urlTo("/statuts/"),
};

function urlTo(path: string): string {
  return `${process.env.NEXT_PUBLIC_CQLP_WEBSITE_URL}${path}`;
}
